import { render, staticRenderFns } from "./ActivityReceive.vue?vue&type=template&id=794370e5&scoped=true&"
import script from "./ActivityReceive.vue?vue&type=script&lang=js&"
export * from "./ActivityReceive.vue?vue&type=script&lang=js&"
import style0 from "./ActivityReceive.vue?vue&type=style&index=0&id=794370e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794370e5",
  null
  
)

export default component.exports